// React
import React from "react";
import CalendarEdit from "./CalendarEdit";

const GroupCalendarEditAppointments = props => (
    <CalendarEdit {...props} calendarType="appointments" />
);
export default GroupCalendarEditAppointments;